<template>
  <div
    class="historyManagerContainer"
    :style="{ width: containerWidth + 'px' }"
  >
    <div class="historyBox">
      <div>
        <i
          class="el-icon-s-fold"
          style="font-size: 25px; cursor: pointer; color: #409eff"
          @click="showHistoryHandle"
        ></i>
        <!-- <i v-if="tableShow" class="el-icon-tickets" style="font-size: 20px;cursor: pointer;color: #409eff;" @click="tableHistory"></i> -->
        <div
          v-if="tableShow"
          style="font-size: 20px; cursor: pointer; color: #409eff"
          @click="tableHistory"
        >
          <SvgIcon
            :iconClass="'qiehuanmoshi'"
            :styleInfo="{ fontSize: '22px' }"
          />
        </div>
      </div>
      <div
        v-if="historyType != 'novelty'"
        style="margin-left: 10px; margin-right: 10px"
      >
        <el-input placeholder="搜索历史记录" v-model="searchKey" clearable>
          <template slot="append">
            <div @click="searchHandle" class="search">
              <i class="el-icon-search"></i>
            </div>
          </template>
        </el-input>
      </div>
      <div v-else>历史记录</div>
      <div>
        <div v-if="historyType === 'add'">
          <el-button
            type="primary"
            style="
              height: 35px;
              width: 60px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
            @click="handleAddCommand"
          >
            新增
          </el-button>
        </div>
        <div v-else>
          <el-button
            type="primary"
            style="
              height: 35px;
              width: 60px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
            @click="handleAdd"
            >新增</el-button
          >
        </div>
      </div>
    </div>

    <div
      ref="scrollWrapper"
      class="historyList"
      :style="{ maxHeight: historyListMaxHeight }"
    >
      <div
        v-for="(item, index) in historyInfoList"
        :key="index"
        class="historyContent"
      >
        <div>
          <div v-if="!item.renameFlag">
            <div
              v-if="historyType === 'add'"
              @click="historyHandle(item, index)"
              style="cursor: pointer"
              :class="[activeHistory === index ? 'activeHistroy' : '']"
              class="historyItemContent"
            >
              <div v-if="typeInfo === 'newWrite'">
                <div
                  :title="item.title"
                  class="textContent title-text"
                  :class="{ 'compact-text': containerWidth < 300 }"
                >
                  <span class="serial-number">{{ startIndex + index }}.</span>
                  发明名称：{{ item.title }}
                </div>
              </div>
              <div v-else>
                <div
                  v-if="item.topicName"
                  :title="item.topicName"
                  class="textContent title-text"
                  :class="{ 'compact-text': containerWidth < 300 }"
                >
                  <span class="serial-number">{{ startIndex + index }}.</span>
                  选题名称：{{ item.topicName }}
                </div>
                <div
                  v-else
                  :title="item.title"
                  class="textContent title-text"
                  :class="{ 'compact-text': containerWidth < 300 }"
                >
                  <span class="serial-number">{{ startIndex + index }}.</span>
                  交底书名称：{{ item.title }}
                </div>
              </div>
              <div
                style="margin-bottom: 10px; font-size: 14px"
                @click.stop="historyHandle(item, index)"
                class="textContent time-text"
                :class="{ 'compact-text': containerWidth < 300 }"
              >
                创建时间：{{
                  item.createdAt | formatTime("YYYY-MM-DD HH: mm: ss")
                }}
              </div>
              <div style="display: flex">
                <div
                  v-if="item.allFieldsFilled && typeInfo === 'technical'"
                  class="writeFiveBooks"
                  style="margin-right: 10px"
                  @click.stop="writeFiveBooks(item)"
                >
                  撰写五书
                </div>
                <div
                  v-if="item.documentId && typeInfo === 'technical'"
                  class="writeFiveBooks"
                  @click.stop="lookFiveBooks(item)"
                >
                  查看五书
                </div>
              </div>
            </div>
            <div
              v-else
              @click.stop="historyHandle(item, index)"
              class="historyItemContent"
            >
              <div
                :class="[
                  activeHistory === index ? 'activeHistroy' : 'historyTitle',
                  'title-text',
                ]"
                style="cursor: pointer"
                :title="item.title"
              >
                <span v-if="item.title" class="serial-number"
                  >{{ startIndex + index }}.</span
                >
                <span class="title-content">{{ item.title }}</span>
              </div>
              <div
                :class="[
                  activeHistory === index ? 'activeHistroy' : 'historyTitle',
                  'time-text',
                  { 'compact-text': containerWidth < 300 },
                ]"
                style="font-size: 12px; color: #9ca3af; cursor: pointer"
              >
                {{ item.createTime | formatTime("YYYY-MM-DD HH:mm:ss") }}
              </div>
            </div>
          </div>
          <div v-if="item.renameFlag" class="editTitle">
            <div style="flex: 1; margin-right: 15px">
              <div style="margin-bottom: 8px; font-size: 12px; color: #909399">
                <span class="serial-number">{{ startIndex + index }}.</span>
                重命名标题
              </div>
              <el-input v-model="item.title"></el-input>
            </div>
            <div style="display: flex; flex-wrap: wrap; gap: 5px">
              <i
                class="el-icon-check"
                style="color: #67c23a; font-size: 20px; cursor: pointer"
                @click.stop="checkHandle(item, index)"
              ></i>
              <i
                class="el-icon-close"
                style="color: #f56c6c; font-size: 20px; cursor: pointer"
                @click.stop="closeHandle(index)"
              ></i>
            </div>
          </div>
        </div>
        <div
          v-if="
            historyType === 'add' ||
            historyType === 'creativeName' ||
            historyType === 'invention'
          "
          class="actionButtons"
          :class="{ compact: containerWidth < 280 }"
        >
          <el-button
            type="text"
            v-if="
              item.allFieldsFilled &&
              typeInfo === 'technical' &&
              historyType !== 'invention'
            "
            size="mini"
            :title="containerWidth < 280 ? '下载' : ''"
          >
            <i class="el-icon-download" @click.stop="downloadHandle(item)"></i>
          </el-button>
          <el-button
            type="text"
            size="mini"
            :title="containerWidth < 280 ? '删除' : ''"
          >
            <i
              class="el-icon-delete"
              style="color: red"
              @click.stop="handleDelete(item)"
            ></i>
          </el-button>
        </div>
        <div
          v-else
          class="actionButtons"
          :class="{ compact: containerWidth < 280 }"
        >
          <div v-if="!item.renameFlag" style="cursor: pointer">
            <el-dropdown
              @command="handleCommand($event, item, index)"
              size="mini"
            >
              <span
                class="el-dropdown-link"
                :title="containerWidth < 280 ? '更多操作' : ''"
              >
                <i class="el-icon-more-outline"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="historyType === 'novelty'"
                  command="download"
                >
                  <div>
                    <i class="el-icon-download"></i>
                    下载
                  </div>
                </el-dropdown-item>
                <el-dropdown-item v-else command="rename">
                  <div>
                    <i class="el-icon-edit"></i>
                    重命名
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="delete">
                  <div>
                    <i class="el-icon-delete"></i>
                    删除
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <!-- 滚动加载提示 -->
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          color: #afafaf;
          font-size: 14px;
          padding: 10px 0;
        "
      >
        <div v-if="loading">加载中...</div>
        <div v-if="!loading && !hasMore && historyInfoList.length > 0">
          没有更多历史记录了
        </div>
      </div>
    </div>
    <!-- 分页组件 -->
    <div class="pagination-wrapper">
      <el-pagination
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :page-sizes="[pagination.pageSize, 10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        small
      />
    </div>
    <div class="resizeHandle" @mousedown="startResize"></div>
  </div>
</template>

<script>
  import { formatTime, formatToISO } from "@/utils/fiflter";

  export default {
    name: "HistoryManager",
    props: {
      historyList: {
        type: Array,
        default: () => [],
      },
      activeHistory: {
        type: Number,
        default: -1,
      },
      hasMore: {
        type: Boolean,
        default: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      historyType: {
        type: String,
        default: null,
      },
      typeInfo: {
        type: String,
        default: null,
      },
      tableShow: {
        type: Boolean,
        default: false,
      },
      activeHistoryId: {
        type: [String, Number, null],
        default: null,
      },
      pagination: {
        type: Object,
        default: () => ({
          currentPage: 1,
          pageSize: 10,
          total: 0,
        }),
      },
    },
    data() {
      return {
        searchKey: "",
        historyInfoList: [],
        containerWidth: 300,
        isResizing: false,
        startX: 0,
        startWidth: 0,
        historyListMaxHeight: "calc(100% - 120px)",
      };
    },
    mounted() {
      this.calculateHistoryListMaxHeight();
      window.addEventListener("resize", this.calculateHistoryListMaxHeight);
      this.$refs.scrollWrapper.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.calculateHistoryListMaxHeight);
    },
    computed: {
      allFieldsFilled() {
        const fields = ["f1", "f2", "f3", "f4", "f5", "f6", "f7"];
        const cur = this.historyInfoList[this.activeHistory];
        if (!cur) return false;
        return fields.every((k) => cur[k] != null && cur[k] !== "");
      },
      displayStrategy() {
        if (this.containerWidth < 250) {
          return "compact";
        } else if (this.containerWidth < 350) {
          return "normal";
        } else {
          return "expanded";
        }
      },
      // 计算起始序号，用于分页时序号连续
      startIndex() {
        const { currentPage, pageSize } = this.pagination;
        return (currentPage - 1) * pageSize + 1;
      },
    },
    watch: {
      historyList(newValue) {
        this.historyInfoList = newValue;
      },
      searchKey(newValue) {
        if (newValue === "") {
          this.searchHandle();
        }
      },
    },
    created() {
      this.historyInfoList = this.historyList;
    },
    beforeDestroy() {
      if (this.$refs.scrollWrapper) {
        this.$refs.scrollWrapper.removeEventListener(
          "scroll",
          this.handleScroll,
        );
      }
      document.removeEventListener("mousemove", this.doResize);
      document.removeEventListener("mouseup", this.stopResize);
    },
    methods: {
      handleScroll() {
        const wrapper = this.$refs.scrollWrapper;
        if (!wrapper) return;
        const scrollHeight = wrapper.scrollHeight;
        const scrollTop = wrapper.scrollTop;
        const clientHeight = wrapper.clientHeight;
        // 只有当滚动到底部且不在加载中且还有更多数据时才触发
        if (
          scrollHeight - scrollTop - clientHeight <= 50 &&
          !this.loading &&
          this.hasMore
        ) {
          this.$emit("load-more");
        }
      },
      showHistoryHandle() {
        this.$emit("toggle");
      },
      tableHistory() {
        this.$emit("tableHistory");
      },
      historyHandle(item, index) {
        this.$emit("select", item, index);
      },
      handleAdd() {
        this.$emit("add");
      },
      downloadHandle(item) {
        this.$emit("download", item);
      },
      handleCommand(command, item, index) {
        if (command === "rename") {
          this.handleRename(index);
        } else if (command === "delete") {
          this.handleDelete(item);
        } else {
          this.downloadHandle(item);
        }
      },
      handleRename(index) {
        this.$emit("rename", index);
      },
      handleDelete(item) {
        this.$emit("delete", item);
      },
      checkHandle(item, index) {
        let data = {
          index: index,
          item: item,
        };
        this.$emit("checkHandle", data);
      },
      closeHandle(index) {
        this.$emit("close", index);
      },
      searchHandle() {
        this.$emit("search", this.searchKey);
      },
      handleAddCommand(event) {
        this.$emit("add");
      },
      writeFiveBooks(item) {
        this.$emit("writeFive", item);
      },
      lookFiveBooks(item) {
        this.$emit("lookFive", item);
      },
      handleSizeChange(val) {
        this.$emit("size-change", val);
      },
      handleCurrentChange(val) {
        this.$emit("current-change", val);
      },
      startResize(e) {
        this.isResizing = true;
        this.startX = e.clientX;
        this.startWidth = this.containerWidth;
        document.addEventListener("mousemove", this.doResize);
        document.addEventListener("mouseup", this.stopResize);
        document.body.style.cursor = "col-resize";
        document.body.style.userSelect = "none";
      },
      doResize(e) {
        if (!this.isResizing) return;
        const deltaX = e.clientX - this.startX;
        const newWidth = this.startWidth + deltaX;
        if (newWidth >= 200 && newWidth <= 600) {
          this.containerWidth = newWidth;
          this.$emit("resize", newWidth);
        }
      },
      stopResize() {
        this.isResizing = false;
        document.removeEventListener("mousemove", this.doResize);
        document.removeEventListener("mouseup", this.stopResize);
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
      },
      scrollToTop() {
        const wrapper = this.$refs.scrollWrapper;
        if (wrapper) {
          wrapper.scrollTop = 0;
        }
      },
      calculateHistoryListMaxHeight() {
        this.$nextTick(() => {
          const container = this.$el;
          if (!container) return;

          const historyBox = container.querySelector(".historyBox");
          const paginationWrapper = container.querySelector(
            ".pagination-wrapper",
          );

          if (historyBox && paginationWrapper) {
            const historyBoxHeight = historyBox.offsetHeight;
            const paginationHeight = paginationWrapper.offsetHeight;
            const containerHeight = container.offsetHeight;

            const maxHeight =
              containerHeight - historyBoxHeight - paginationHeight;
            this.historyListMaxHeight = `${maxHeight}px`;
          }
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .historyManagerContainer {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .historyBox {
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    ::v-deep(.el-input-group__append) {
      padding: 0px 10px;
      box-sizing: border-box;
      background-color: none;
    }

    ::v-deep(.el-input__inner) {
      height: 35px;
    }

    ::v-deep(.el-button--primary) {
      position: relative;
      box-shadow: 0 2px 0 0 #0056b3;
      transition: all 0.1s ease;
    }

    ::v-deep(.el-button--primary:active) {
      transform: translateY(2px);
      box-shadow: 0 2px 0 0 #0056b3;
    }
  }

  .historyList {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    min-height: 0;
  }

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(240, 240, 240, 0.3);
    border-radius: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(163, 163, 163, 0.6);
    border-radius: 3px;
    transition: background 0.3s ease;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(120, 120, 120, 0.8);
  }

  .historyContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    font-size: 15px;
    color: #333;
    width: 100%;
    gap: 10px;
  }

  .historyContent > div:first-child {
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }

  .historyContent > div:last-child {
    flex-shrink: 0;
  }

  .historyItemContent {
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }

  /* 标题文本样式 - 单行省略 */
  .title-text {
    font-size: 14px;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .title-content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
  }

  /* 时间文本样式 - 单行显示 */
  .time-text {
    font-size: 12px;
    color: #9ca3af;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.4;
  }

  /* 通用文本容器样式 */
  .textContent {
    word-break: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    transition: all 0.2s ease;
    line-height: 1.4em;
  }

  /* 紧凑模式下的文本样式 */
  .compact-text {
    font-size: 13px !important;
    margin-bottom: 8px !important;
    line-height: 1.3 !important;
  }

  /* 紧凑模式下的标题 - 更严格的宽度限制 */
  @media (max-width: 280px) {
    .compact-text.title-text {
      font-size: 12px !important;
    }
  }

  .serial-number {
    color: #333;
    font-weight: 500;
    margin-right: 6px;
    font-size: 14px;
    min-width: 20px;
    display: inline-block;
  }

  .actionButtons {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    gap: 5px;
  }

  .actionButtons.compact {
    gap: 2px;
  }

  .actionButtons.compact .el-button {
    padding: 2px 4px;
    min-height: auto;
    height: auto;
    line-height: 1;
  }

  @media (max-width: 300px) {
    .actionButtons {
      flex-direction: column;
      gap: 2px;
    }

    .actionButtons .el-button {
      padding: 2px 4px;
      font-size: 12px;
    }

    .editTitle {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
    }

    .editTitle > div:last-child {
      justify-content: center;
      margin-top: 8px;
    }
  }

  /* 窄宽度时的特殊处理 */
  @media (max-width: 250px) {
    .historyContent {
      padding: 15px 10px;
    }

    .serial-number {
      font-size: 11px;
      margin-right: 4px;
      min-width: 16px;
    }

    .actionButtons {
      flex-direction: row;
    }

    .textContent,
    .activeHistroy,
    .historyTitle {
      max-height: 1.4em;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .textContent::after,
    .activeHistroy::after,
    .historyTitle::after {
      display: none;
      /* 窄宽度下使用浏览器原生省略 */
    }
  }

  @media (min-width: 251px) and (max-width: 300px) {
    .editTitle {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
    }

    .editTitle > div:last-child {
      justify-content: center;
      margin-top: 8px;
    }
  }

  .activeHistroy {
    color: #409eff !important;
    max-width: 100%;
    word-break: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    cursor: pointer;
    flex: 1;
    transition: all 0.2s ease;
  }

  .activeHistroy .title-text,
  .activeHistroy .time-text,
  .activeHistroy .serial-number {
    color: #409eff !important;
  }

  .historyTitle {
    max-width: 100%;
    word-break: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    flex: 1;
    transition: all 0.2s ease;
  }

  .editTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 10px;
    flex-wrap: wrap;
  }

  .search {
    cursor: pointer;
  }

  .historyBox ::v-deep .el-input-group__append:hover {
    border: 1px solid #409eff;
  }

  .writeFiveBooks {
    font-size: 14px;
    color: #409eff;
    cursor: pointer;
  }

  .resizeHandle {
    position: absolute;
    right: 4px;
    top: 0;
    bottom: 0;
    width: 4px;
    cursor: col-resize;
    background-color: transparent;
    z-index: 1;

    &:hover {
      background-color: rgba(64, 158, 255, 0.3);
    }
  }

  .pagination-wrapper {
    padding: 10px 5px;
    border-top: 1px solid #eee;
    background-color: #fff;

    ::v-deep .el-pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      gap: 5px;

      .el-pagination__total {
        font-size: 12px;
        color: #606266;
      }

      .el-pagination__sizes {
        .el-input__inner {
          height: 24px;
          line-height: 24px;
          font-size: 12px;
        }
      }

      .el-pager {
        li {
          min-width: 24px;
          height: 24px;
          line-height: 24px;
          font-size: 12px;
          padding: 0 6px;
        }
      }

      .btn-prev,
      .btn-next {
        min-width: 24px;
        height: 24px;
        line-height: 24px;
        padding: 0 6px;
      }

      .el-pagination__jump {
        font-size: 12px;
        color: #606266;
        margin-left: 0;

        .el-input__inner {
          height: 24px;
          line-height: 24px;
          width: 40px;
          font-size: 12px;
        }
      }
    }
  }
</style>
